import React, { useEffect, useState } from 'react';
import { pageTitle } from '../PageTitle';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import { useLocation } from 'react-router-dom';
import parse from 'html-react-parser';
import { fetchSoftware } from '../../DataFetchers/fetchSoftwares';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faLink } from '@fortawesome/free-solid-svg-icons';


const SoftwareDetails = () => {
    pageTitle('Software Details');

    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const softwareName = query.get('software');

    const [software, setSoftware] = useState(null);

    useEffect(() => {
        fetchSoftware(softwareName).then((data) => {
            setSoftware(data.software);
        });
    }, [softwareName]);

    if (!software) return (<></>);

    return (

        <>
            <HeaderOne></HeaderOne>
            <div className="blog__details software__details see__pad">
                <div className="auto-container">
                    <div className="">
                        <div className="blog__details__content ">
                            <div className="blog__inner__box">
                                <h6 style={{ color: "yellow", opacity: 0.8, padding: "0px", margin: "0px" }}>{software.status}</h6>
                                <h3 className="blog__title yellow__text">{software.title}
                                    {software.url && <a href={software.url} target="_blank" rel="noopener noreferrer" style={{ marginLeft: '10px' }}><FontAwesomeIcon icon={faExternalLinkAlt} size="xs" /></a>}
                                </h3>
                                <div className="software__details__text">
                                    {parse(software.description)}
                                </div>
                            </div>
                            <div className="blog__image p_relative">
                                <img src={software.wideImage ?? software.image} alt="" />
                            </div>
                            {software.webPageImage && <div className="blog__image p_relative" style={{ marginTop: '20px' }}>
                                <img src={software.webPageImage} alt="" />
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
            <FooterOne></FooterOne>
        </>
    );
};

export default SoftwareDetails;
